import axios from 'axios';
import {backendHost} from '../../../../store/config';

const getProviderList = (params) => {
    return axios.get(`${backendHost}/api/admin/report-games/list`, {params});
};

export {
    getProviderList
}